import type { BackendCapabilities, BrowserBackend } from "../backend/contracts";

export const LOCAL_KERNEL_CONTRACT_VERSION = 1 as const;
export const LOCAL_APP_MANIFEST_SCHEMA_VERSION = 1 as const;

export type LocalCapability =
  | "local-api"
  | "persistent-storage"
  | "offline-shell"
  | "worker-execution"
  | "snapshots"
  | "cross-tab-sync"
  | "cors-aware-outbound";

export type LocalNetworkMode = "offline-only" | "offline-first" | "optional-network" | "online-required";

export type LocalResourceOperation = "list" | "get" | "create" | "update" | "delete";

export type LocalResourceManifest = {
  id: string;
  version: number;
  route: string;
  operations: readonly LocalResourceOperation[];
};

export type LocalAppManifest = {
  schemaVersion: typeof LOCAL_APP_MANIFEST_SCHEMA_VERSION;
  id: string;
  version: string;
  dataSchemaVersion: number;
  label: string;
  description: string;
  path: string;
  storageNamespace: string;
  offline: boolean;
  network: LocalNetworkMode;
  networkNote: string;
  license: string;
  requiredCapabilities: readonly LocalCapability[];
  resources: readonly LocalResourceManifest[];
};

export type LocalCapabilityStatus = {
  capability: LocalCapability;
  available: boolean;
};

export type LocalWorkspaceKernelDescriptor = {
  kind: "browser-local-kernel";
  contractVersion: typeof LOCAL_KERNEL_CONTRACT_VERSION;
  generatedAt: string;
  capabilities: BackendCapabilities;
  capabilityStatus: readonly LocalCapabilityStatus[];
  apps: readonly LocalAppManifest[];
};

export type LocalWorkspaceKernelOptions = {
  permissionStore?: import("./permissions").LocalPermissionStore;
  environment?: {
    hasServiceWorker: boolean;
    hasWorker: boolean;
    hasBroadcastChannel: boolean;
  };
};

export type KernelBackend = Pick<BrowserBackend, "capabilities" | "start" | "request">;
